var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2[OrderType2["NO_RESTRICTION"] = 0] = "NO_RESTRICTION";
  OrderType2[OrderType2["IMMEDIATE_OR_CANCEL"] = 1] = "IMMEDIATE_OR_CANCEL";
  OrderType2[OrderType2["FILL_OR_KILL"] = 2] = "FILL_OR_KILL";
  OrderType2[OrderType2["POST_ONLY"] = 3] = "POST_ONLY";
  return OrderType2;
})(OrderType || {});
var SelfMatchingOptions = /* @__PURE__ */ ((SelfMatchingOptions2) => {
  SelfMatchingOptions2[SelfMatchingOptions2["SELF_MATCHING_ALLOWED"] = 0] = "SELF_MATCHING_ALLOWED";
  SelfMatchingOptions2[SelfMatchingOptions2["CANCEL_TAKER"] = 1] = "CANCEL_TAKER";
  SelfMatchingOptions2[SelfMatchingOptions2["CANCEL_MAKER"] = 2] = "CANCEL_MAKER";
  return SelfMatchingOptions2;
})(SelfMatchingOptions || {});
export {
  OrderType,
  SelfMatchingOptions
};
//# sourceMappingURL=index.js.map
